import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import dayjs from 'dayjs';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import {
  DataGridCell,
  exportDataGrid,
} from 'devextreme-react/cjs/common/export/excel';
import { base64HeaderImage } from '../constants';

export async function xlsxSaver(
  e: DataGridTypes.ExportingEvent,
  title: string,
  headerTitleForSheet?: string,
  reportHeaderTagLine?: string,
  customizeCell?: ({
    gridCell,
    excelCell,
  }: {
    gridCell?: DataGridCell;
    excelCell?: any;
  }) => void,
  handleNewSheet?: (
    workBook: Workbook,
    headerImageId: number,
    reportHeaderTagLine?: string,
    headerTitleForSheet?: string
  ) => Promise<void>
) {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main');

  const headerRow = worksheet.getRow(1);
  headerRow.height = 55;
  worksheet.mergeCells(1, 1, 1, 2); // logo
  worksheet.mergeCells(1, 3, 1, 13); // title

  const mainSheet = workbook.getWorksheet('Main');
  mainSheet.getRow(3).font = { bold: true };
  const headerImageId = workbook.addImage({
    base64: base64HeaderImage,
    extension: 'png',
  });
  mainSheet.addImage(headerImageId, {
    tl: { col: 0.6, row: 0.95 },
    ext: { width: 200, height: 30 },
  });

  await handleNewSheet?.(
    workbook,
    headerImageId,
    reportHeaderTagLine,
    headerTitleForSheet
  );

  headerRow.getCell(1).alignment = {
    vertical: 'middle',
    horizontal: 'center',
  };
  headerRow.getCell(3).font = {
    bold: true,
    size: 24,
  };
  headerRow.getCell(3).alignment = {
    vertical: 'middle',
    horizontal: 'left',
  };
  headerRow.getCell(3).value = headerTitleForSheet ?? 'Report';
  if (worksheet.name === 'Main') {
    worksheet.mergeCells(2, 1, 2, 13);
    worksheet.getRow(2).getCell(1).alignment = {
      vertical: 'middle',
      horizontal: 'left',
    };
    worksheet.getRow(2).getCell(1).font = { bold: true, size: 12 };
    worksheet.getRow(2).getCell(1).value = reportHeaderTagLine ?? '';
  }

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
    topLeftCell: { row: 3, column: 1 },
    customizeCell,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
        `${title + dayjs().format('DDMMYYYY')}.xlsx`
      );
    });
  });
}
